<template>
  <v-dialog
    :model-value="modelValue"
    persistent
    max-width="290"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="$emit('confirm')">
          Confirm
        </v-btn>
        <v-btn color="green darken-1" text @click="$emit('cancel')">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    title: String,
    message: String,
    modelValue: Boolean,
  },
  emits: ["update:modelValue", "confirm", "cancel"],
};
</script>
